
<template>
  <div v-wechat-title="title">
    <NativeBar ref="menu" v-model="NativeBarId" />
    <div class="toptoolBar">
      <van-row>
        <van-col span="12"> <div class="checkAll"><van-checkbox v-model="checkAll" :checked-color="GetColorMain()" @click="onCheckAll">全选</van-checkbox></div></van-col>
        <van-col span="12" class="rigth"><span @click="onEdit">{{ isEdit?'完成':'编辑' }}</span></van-col>
      </van-row>
    </div>
    <div class="carList">
      <div class="emptyRect1" />
      <van-checkbox-group v-model="result" @change="onCheckboxChange">
        <div v-if="list.length<=0" class="emptyList" @click="onGotoList">
          空空如也，前往选购
        </div>
        <div v-for="(item,index) in list" :key="item.carId" class="item">
          <div class="checkbox">
            <van-checkbox
              :key="item.carId"
              :disabled="!item.isEnable && !isEdit"
              :name="item.carId"
              :checked-color="GetColorMain()"
            />
          </div>
          <div class="rect">
            <van-image
              width="6em"
              height="6em"
              :src="item.commodityicon?item.commodityicon:'/img/defaultcom.jpg'"
              @click="onItem(item.commodityId)"
            />
            <div v-if="!item.isEnable" class="needDiy">
              <span>已下架</span>
            </div>
            <div v-else-if="item.diyType!=='NONE' && !item.isHaveDiyData" class="needDiy">
              <span>需要完善定做数据</span>
            </div>
            <div class="infos">
              <div class="title" @click="onItem(item.commodityId)">
                <van-tag v-if="item.type==='VIRTUAL'" plain type="danger">虚拟</van-tag>
                {{ item.commodityname }}
              </div>
              <div class="specifications" @click="onItem(item.commodityId)">
                <van-tag v-if="item.diyTitle" plain type="danger">{{ cutString(item.diyTitle,10) }}</van-tag>
                {{ item.SpecificationMainName }}
                <span v-if="item.tripBeginTime && !item.tripEndTime">{{ formatDate(item.tripBeginTime,"yyyy/MM/dd") }}</span>
                <span v-if="item.tripBeginTime && item.tripEndTime">{{ formatDate(item.tripBeginTime,"yyyy/MM/dd") }}~{{ formatDate(item.tripEndTime,"yyyy/MM/dd") }}</span>
                <template v-if="item && item.SpecificationOtherNames">
                  <span v-for="sp in item.SpecificationOtherNames.split('/')" :key="sp">
                    {{ sp }}
                  </span>
                </template>

              </div>
              <div class="priceLine">
                <div class="price" :style="'color: '+GetColorMain()" @click="onItem(item.commodityId)">
                  <!-- ￥<span>{{ parseInt(item.commodityprice) }}</span>.{{ ("0"+parseInt((100*item.commodityprice-100*parseInt(item.commodityprice)))).slice(-2) }} -->

                  <template v-if="item.stepBuy === 'SECOND_CNY'">
                    ￥<span>{{ parseInt(item.stepPrice) }}</span>.{{ ("0"+parseInt((100*item.stepPrice+0.5-100*parseInt(item.stepPrice)))).slice(-2) }}
                    <!-- <br><van-tag plain type="danger" class="stepPrice">尾款:￥{{ ShowMoney(item.commodityprice) }}</van-tag> -->
                  </template>
                  <template v-if="item.stepBuy !== 'SECOND_CNY'">
                    ￥<span>{{ parseInt(item.commodityprice) }}</span>.{{ ("0"+parseInt((100*item.commodityprice+0.5-100*parseInt(item.commodityprice)))).slice(-2) }}
                    <!-- <van-tag v-if="item.stepBuy === 'SECOND_OTHER'" plain type="danger" class="stepPrice">尾款:{{ item.stepCurrency }} {{ ShowMoney(item.commodityprice) }}</van-tag> -->
                  </template>
                </div>
                <div class="num">
                  <van-stepper v-model="list[index].num" integer @change="onChangeNum(item)" />
                </div>
              </div>

              <div class="tag">
                <van-tag v-if="item.stepBuy === 'SECOND_CNY'" round plain class="stepPrice">尾款:￥{{ ShowMoney(item.commodityprice-item.stepPrice) }}</van-tag>
                <van-tag v-if="item.stepBuy === 'SECOND_OTHER'" round plain class="stepPrice">尾款:{{ item.stepCurrency }} {{ ShowMoney(item.commodityprice) }}</van-tag>
                <van-tag v-if="item.diyTitle" round plain type="success">定制</van-tag>
                <template v-if="item && item.activityTags">
                  <van-tag v-for="activity in item.activityTags.split('/')" :key="activity" round plain type="success">{{ activity }}</van-tag>
                </template>
                <!-- <van-tag round plain type="success">新品</van-tag>
                <van-tag round plain type="danger">会员满1000减100</van-tag> -->
              </div>
            </div>
          </div>

        </div>
      </van-checkbox-group>
    </div>
    <div class="emptyRect" />
    <div class="emptyRect1" />
    <div class="toolBar">
      <van-row v-if="!isEdit">
        <van-col span="16"><div class="priceAll">合计：<span>￥{{ totalPrice.toFixed(2) }}</span></div></van-col>
        <van-col span="8"><van-button type="warning" square style="height: 48px;width:100%;" :color="GetColorMain()" @click="onBuy">去结算({{ totalNum }})</van-button></van-col>
      </van-row>
      <van-row v-if="isEdit">
        <van-col span="16" />
        <van-col span="8" class="rigth editButton"><van-button type="default" round plain size="small" :loading="loadingDelete" @click="onDeleteItem">删除</van-button></van-col>
      </van-row>
    </div>
    <van-popup v-model="selectCommodityVisibla" class="selectCommodityRect">
      <div class="title">请分开结算以下商品</div>
      <van-radio-group v-model="selectCommodity">
        <van-radio v-for="(item,index) in stepCommoditys" :key="index" :checked-color="GetColorMain()" style="padding:0.5em 0" :name="item.carId">{{ item.commodityshortName }} - {{ item.SpecificationMainName }}<br><span>(含尾款的商品)</span></van-radio>
        <van-radio v-if="baseCommoditys.length>0" :checked-color="GetColorMain()" style="padding:0.5em 0" :name="0">其他商品<br><span>{{ baseCommoditys.length }}件</span></van-radio>
        <van-radio v-if="virtualCommoditys.length>0" :checked-color="GetColorMain()" style="padding:0.5em 0" :name="-1">虚拟商品<br><span>{{ virtualCommoditys.length }}件</span></van-radio>
      </van-radio-group>
      <br>
      <van-row>
        <van-col span="12"><van-button plain type="primary" round size="small" :color="GetColorMain()" style="width:25vw" @click="selectCommodityVisibla=false">返回购物车</van-button></van-col>
        <van-col span="12" class="rigth"><van-button type="primary" round size="small" :color="GetColorMain()" style="width:25vw" @click="onSelectCommodity()">去结算</van-button></van-col>
      </van-row>
    </van-popup>
    <diySelect v-model="showDiySelect" :specification-id="selectDiyId" @onChange="onDiyDataChange" />
  </div>
</template>
<script>
import request from '@/utils/request'
import NativeBar from '@/components/NativeBar'
import { Button, Checkbox, CheckboxGroup, Image, Stepper, Tag, Popup, RadioGroup, Radio, Dialog } from 'vant'
import { MyNotify, formatDate } from '@/utils/base'
import commonData from '@/commondata.js'
import { cutString, ShowMoney, GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
import diySelect from '@/components/diySelect'
export default {
  name: 'StoreCar',
  components: {
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Image.name]: Image,
    [Stepper.name]: Stepper,
    [Tag.name]: Tag,
    [Popup.name]: Popup,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Dialog.name]: Dialog,
    NativeBar,
    diySelect
  },
  data() {
    return {
      title: '购物车',
      isFirst: true,
      NativeBarId: '',
      checkAll: true,
      result: [],
      saveResultSelect: [],
      saveCheckAllSelect: false,
      saveResultEdit: [],
      saveCheckAllEdit: false,
      list: [],
      totalPrice: 0,
      totalNum: 0,
      isEdit: false,
      loadingDelete: false,
      selectCommodityVisibla: false,
      baseCommoditys: [],
      virtualCommoditys: [],
      stepCommoditys: [],
      selectCommodity: undefined,
      showDiySelect: false,
      selectDiyId: undefined,
      selectCarId: undefined
    }
  },
  activated() {
    if (this.isFirst) {
      return
    }
    this.onInit(() => {
    })
    this.$refs.menu.resetNum()
    this.NativeBarId = ''
    setTimeout(() => {
      this.NativeBarId = 'car'
    }, 0)
    if (this.isEdit) {
      this.onEdit()
    }
  },
  created() {
    this.onInit()
    this.NativeBarId = ''
    setTimeout(() => {
      this.NativeBarId = 'car'
    }, 0)
  },
  methods: {
    cutString,
    formatDate,
    ShowMoney,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    onCheckboxChange(selectList) {
      // console.log('onCheckboxChange', selectList.length)
      // console.log('onCheckboxChange', this.list.length)
      if (selectList.length === this.list.length) {
        this.checkAll = true
      } else {
        this.checkAll = false
      }
      this.onLoadTotal()
    },
    onChangeNum(item) {
      // console.log('onChangeNum', item)
      request({
        url: '/StoreHelper/editShoppingCarNum',
        method: 'post',
        data: {
          carId: item.carId,
          num: item.num
        }
      }).then(response => {
        if (!response.success) {
          return
        }
      })
      this.onLoadTotal()
    },

    onCheckAll() {
      if (!this.checkAll) {
        this.result = []
        this.list.map((item) => {
          if (item.isEnable) {
            this.result.push(item.carId)
          }
        })
      } else {
        this.result = []
      }
      this.onLoadTotal()
    },
    onLoadTotal() {
      // console.log('onLoadTotal')
      var num = 0
      var price = 0
      this.list.map((item) => {
        var find = this.result.find((id) => id === item.carId)
        if (find) {
          num += item.num
          if (item.stepBuy === 'SECOND_CNY') {
            price += item.num * item.stepPrice
          } else {
            price += item.num * item.commodityprice
          }
        }
      })
      this.totalNum = num
      this.totalPrice = price
    },
    onItem(id) {
      this.$router.push('/store/item/' + id)
    },
    onInit(callback) {
      // console.log('onInit')
      request({
        url: '/StoreHelper/getShoppingCarList',
        method: 'post'
      }).then(response => {
        this.isFirst = false
        if (!response.success) {
          return
        }
        this.list = response.data
        this.list.map((item) => {
          if (item.isEnable) {
            this.result.push(item.carId)
          }
        })
        this.onLoadTotal()
        commonData.shoppingCarNum = this.list.length
        commonData.shoppingCarSaveNum = this.list.length
        this.$refs.menu.resetNum()
        if (callback) {
          callback()
        }
      })
    },
    onGotoList() {
      this.$router.push('/store/list')
    },
    onRestNum() {
      commonData.shoppingCarNum = this.list.length
      commonData.shoppingCarSaveNum = commonData.shoppingCarNum
      this.$refs.menu.resetNum()
    },
    onEdit() {
      if (!this.isEdit) {
        this.saveCheckAllSelect = this.checkAll
        this.saveResultSelect = JSON.parse(JSON.stringify(this.result))

        this.checkAll = this.saveCheckAllEdit
        this.result = []
        this.saveResultEdit.map((item) => {
          this.result.push(item)
        })
      } else {
        this.saveCheckAllEdit = this.checkAll
        this.saveResultEdit = JSON.parse(JSON.stringify(this.result))

        this.checkAll = this.saveCheckAllSelect
        this.result = []
        this.saveResultSelect.map((item) => {
          this.result.push(item)
        })
      }
      this.isEdit = !this.isEdit
    },
    onDeleteItem() {
      if (this.result.length <= 0) {
        return
      }
      if (this.loadingDelete) {
        return
      }
      this.loadingDelete = true
      // console.log('删除', this.result)
      request({
        url: '/StoreHelper/deleteShoppingCar',
        method: 'post',
        data: {
          carId: this.result,
          type: 'ACTIVE'
        }
      }).then(response => {
        this.loadingDelete = false
        if (!response.success) {
          return
        }
        this.list = this.list.filter((item) =>
          !this.result.find((id) => id === item.carId)
        )

        this.onRestNum()
        MyNotify('success', '删除成功', 2000)
      })
    },
    onDiyDataChange(data) {
      console.log('定做信息', data)
      if (!this.selectCarId || !data) {
        return
      }
      request({
        url: '/StoreHelper/updateShoppingCarDiyData',
        method: 'post',
        data: {
          carId: this.selectCarId,
          diyTitle: data.title,
          diyInfo: JSON.stringify(data)
        }
      }).then(response => {
        if (!response.success) {
          return
        }
        this.list.map((item) => {
          if (item.carId === this.selectCarId) {
            item.isHaveDiyData = true
            item.diyTitle = data.title
          }
        })
      })
    },
    onBuy() {
      console.log('onBuy')
      this.virtualCommoditys = []
      this.baseCommoditys = []
      this.stepCommoditys = []
      var diyErrorspecificationId
      var diyErrorName
      this.list.map((item) => {
        var find = this.result.find((id) => id === item.carId)
        if (find && item.diyType !== 'NONE' && !item.isHaveDiyData && !diyErrorspecificationId) {
          diyErrorspecificationId = item.SpecificationMainId
          diyErrorName = item.commodityshortName
          this.selectCarId = item.carId
        }
        if (find) {
          console.log('item', item)
          if (item.stepBuy === 'NONE') {
            if (item.type === 'VIRTUAL') {
              this.virtualCommoditys.push(item)
            } else {
              this.baseCommoditys.push(item)
            }
          } else {
            this.stepCommoditys.push(item)
          }
        }
      })
      if (diyErrorspecificationId) {
        Dialog.confirm({
          title: '完善定做信息',
          message: '您要结算的商品中：' + diyErrorName + ' 需要完善定做信息,是否现在完善?',
          confirmButtonText: '完善信息'
        }).then(() => {
          this.selectDiyId = diyErrorspecificationId
          this.showDiySelect = true
        })
        return
      }
      var i = 0
      if (this.stepCommoditys.length >= 2) {
        i = i + 2
      }
      if (this.baseCommoditys.length > 0) {
        i = i + 1
      }
      if (this.stepCommoditys.length > 0) {
        i = i + 1
      }
      if (this.virtualCommoditys.length > 0) {
        i = i + 1
      }
      if (i >= 2) {
        this.selectCommodityVisibla = true
        return
      }

      var buyList = []
      this.list.map((item) => {
        var find = this.result.find((id) => id === item.carId)
        if (find) {
          buyList.push(item)
        }
      })
      this.buyItem(buyList)
    },
    onSelectCommodity() {
      console.log('selectCommodity', this.selectCommodity)
      if (!this.selectCommodity && this.selectCommodity !== 0) {
        MyNotify('info', '请选择一个需要结算的商品', 2000)
        return
      }

      if (this.selectCommodity === 0) {
        this.buyItem(this.baseCommoditys)
      } else if (this.selectCommodity === -1) {
        this.buyItem(this.virtualCommoditys)
      } else {
        this.buyItem(this.stepCommoditys.filter(item => item.carId === this.selectCommodity))
      }
    },
    buyItem(buyList) {
      var data = ''
      buyList.map((item) => {
        data += item.commodityId + '|' +
        item.num + '|' +
        item.SpecificationMainId + '|' +
        (item.SpecificationOtherIds ? item.SpecificationOtherIds : '') +
        '||' + item.carId + '|' +
        (item.tripBeginTime ? formatDate(item.tripBeginTime, 'yyyy/MM/dd') : '') + '|' +
        (item.tripEndTime ? formatDate(item.tripEndTime, 'yyyy/MM/dd') : '') + '|'
      })
      this.$router.push('/store/ordercreate?data=' + data)
    }
  }
}
</script>
<style scoped>
.carList{
  background-color: #fff;
  min-height: 100vh;
  padding-top: 1em;
}
.emptyRect{
  height: 50px;
}
.emptyRect1{
  height: 3em;
}
.emptyRect2{
  height: 2em;
}
.item {
  padding: 0.5em 0.5em 0.5em 0.5em;
  height: 6em;
  position: relative;

}
.item .checkbox
{
  position: absolute;
  top: 2.5em;
}
.item .rect
{
  padding: 0.3em;
  box-shadow: 3px 3px 10px #eaeaea;
  position: absolute;
  left: 2em;
  top: 0;
  right: 0.5em;
  height: 6em;
  background-color: #fff;
}
.item .rect .infos{
  position: absolute;
  left: 6.8em;
  top: 0.3em;
  right: 0.3em;
  height: 6em;
}
.item .rect .infos .title{
    overflow: hidden;
    display: -webkit-box;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    font-size: 0.9em;
}
.item .rect .infos .specifications{
  color: #999;
  font-size: 0.8em;
  line-height: 2em;
}
.priceLine{
  position: relative;
  height: 1.8em;
}
.priceLine .price{
  color: #f00;
  float: left;

}
.priceLine .price span
{
  font-size: 1.3em;
}
.tag .stepPrice{
  margin-left: 0.3em;
  color: #999;
}
.priceLine .num{
  float: right;
  font-size:0.7em;
  color: #999;
}
.toolBar{
  position: fixed;
  height: 3em;
  border-top: #fafafa 1px solid;
  left: 0;
  right: 0;
  bottom: 50px;
  background: -webkit-linear-gradient(#fff, #f7f7f7); /* Safari 5.1 - 6.0 */
  background: -o-linear-gradient(#fff, #f7f7f7); /* Opera 11.1 - 12.0 */
  background: -moz-linear-gradient(#fff, #f7f7f7);/* Firefox 3.6 - 15 */
  background: linear-gradient(#fff, #f7f7f7); /* 标准的语法 */
  z-index: 10;
}
.toolBar .priceAll{
  line-height: 3em;
  padding-left: 2.5em;

}
.toolBar .priceAll span{
  font-weight: 700;
}
.toptoolBar{
  position: fixed;
  height: 3em;
  border-bottom: #fafafa 1px solid;
  left: 0;
  right: 0;
  top: 0;
  background-color: #fff;
  z-index: 10;
  line-height: 3em;
  padding: 0 0.5em;
}
.toptoolBar .checkAll{
  padding:1em 0;
}
.editButton button{
  margin: 10px 1em 0 0 ;
}
.tag span{
  padding: 0.3em 0.5em;
  line-height: 1em;
  margin: 0.3em 0.6em 0.3em 0;
}

.emptyList{
  text-align: center;
  color: #999;
  margin-top: 35vh;
}
.selectCommodityRect{
  width: 80%;
  padding: 1em;
  border-radius: 0.5em;
}
.selectCommodityRect .title{
  padding-bottom: 1em;
}
.selectCommodityRect .van-radio span{
  font-size: 0.8em;
  color: #999;
}
.needDiy{
  position: absolute;
  width: 100%;
  height: 6em;
  top:0.3em;
  background-color: #000;
  color: #fff;
  line-height: 6em;
  z-index: 1;
  text-align: center;
  filter:alpha(Opacity=40);
  -moz-opacity:0.4;
  opacity: 0.4;
}
.needDiy span{
  font-size: 1.7em;
}
</style>
